module.exports = __webpack_public_path__ + "img/flavor10.084445f4.svg";